// removed by extract-text-webpack-plugin
module.exports = {"bubble":"bubble_8d7","scaleIn":"scaleIn_Ma0","bubbleLeaving":"bubbleLeaving_2CV","scaleOut":"scaleOut_1Gz","tooltipContent":"tooltipContent_1Yv","tooltipButton":"tooltipButton_2Pl","tooltipButtonImg":"tooltipButtonImg_1y_","tooltipInfo":"tooltipInfo_3wR","tooltipInfoDark":"tooltipInfoDark_246","tooltipHeading":"tooltipHeading_12s","backgroundFadeIn":"backgroundFadeIn_1xM","backgroundFadeOut":"backgroundFadeOut_2dd","opacityIn":"opacityIn_2UX","opacityOut":"opacityOut_1Tc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/budget-bubble/budget-bubble.scss
// module id = 643
// module chunks = 0 1